import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

export const useCasinoPermission = () => {
    const [hasCasinoPermission, setHasCasinoPermission] = useState(null);
    const [hasSlotPermission, setHasSlotPermission] = useState(null);
    const [loading, setLoading] = useState(true);
    const user = useSelector((state) => state.auth.user);

    useEffect(() => {
        const checkPermissions = () => {
            if (!user) {
                setHasCasinoPermission(false);
                setHasSlotPermission(false);
                setLoading(false);
                return;
            }

            // Check if casino is enabled in user data
            const isCasinoEnabled = user.isCasinoEnabled;
            const casinoTypeInfo = user.casinoTypeInfo || [];

            if (!isCasinoEnabled) {
                setHasCasinoPermission(false);
                setHasSlotPermission(false);
            } else {
                // Check casino type permissions
                const hasGapiPermission = casinoTypeInfo.some(type => type.id === 1 && type.isAllowed);
                const hasVivoPermission = casinoTypeInfo.some(type => type.id === 2 && type.isAllowed);

                // Gapi (id: 1) = slots
                // Vivo (id: 2) = live casino
                setHasSlotPermission(hasGapiPermission);
                setHasCasinoPermission(hasVivoPermission);
            }

            setLoading(false);
        };

        checkPermissions();
    }, [user]);

    return {
        hasCasinoPermission,
        hasSlotPermission,
        loading
    };
};
